import React  from 'react';
import { useTranslation } from 'react-i18next';
import ColorPicker from "../../../../../../../components/ColorPicker";
import CustomChip from "../../../../../../../components/CustomChip";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Render a single row in the color palette editor with label, background color picker,
 * text color picker, and a preview chip.
 *
 * @param {string} key - Unique identifier for the row (used as HTML id).
 * @param {string} labelKey - Translation key for the label text of this row.
 * @param {string} bgName - Property name in `item` representing the background color.
 * @param {string} txtName - Property name in `item` representing the text color.
 * @param {string} idBase - Base identifier used for constructing element ids.
 * @param {Object} item - Object containing the current color values.
 * @param {Function} onChange - Callback function triggered when a color changes.
 *
 */

const ColorRow = ({ key , labelKey, bgName, txtName, idBase, item, onChange}) => {
    const { t } = useTranslation();

    return   <div className="row background-shades-50 border-full-shades-100 py-12px border-radius-8px px-2 px-sm-0 mx-0" id={key}>
        {/* LABEL */}
        <div className="col-12 col-sm-4 d-flex align-items-center mb-2 mb-sm-0">
                <span className="fs-16px ibl-font-w-600 font-color-general-950">
                    {t(labelKey)}
                </span>
        </div>

        {/* BG */}
        <div className="col-12 col-sm-3 mb-2 mb-sm-0 right-vertical-separator right-vertical-separator-sm">
            <div className="d-block d-sm-none fs-12px ibl-font-w-600 font-color-general-950 mb-1">
                {t("background_hex")}
            </div>
            <ColorPicker
                id={`clp_pc_color_${idBase}_bg`}
                name={bgName}
                color={item?.[bgName]}
                onChange={onChange}
            />
        </div>

        {/* TEXT */}
        <div className="col-12 col-sm-3 mb-2 mb-sm-0 right-vertical-separator right-vertical-separator-sm">
            <div className="d-block d-sm-none fs-12px ibl-font-w-600 font-color-general-950 mb-1">
                {t("text_hex")}
            </div>
            <ColorPicker
                id={`clp_pc_color_${idBase}_txt`}
                name={txtName}
                color={item?.[txtName]}
                onChange={onChange}
            />
        </div>

        {/* PREVIEW */}
        <div className="col-12 col-sm-2 d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
            <div className="d-block d-sm-none fs-12px ibl-font-w-600 font-color-general-950 mb-1">
                {t("preview")}
            </div>
            <CustomChip
                background={item?.[bgName]}
                fontColor={item?.[txtName]}
                legend={t(labelKey)}
                variant="compact"
            />
        </div>
    </div>;
};

export default ColorRow;
